module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed-position homeHeader"
  }, [_c('div', {
    class: ['head-bar', {
      headBarBorder: _vm.showLine
    }]
  }, [_c('div', {
    staticClass: "head-top"
  }, [_c('div', {
    staticClass: "top-container"
  }, [_c('div', {
    staticClass: "top-left"
  }, [_c('img', {
    staticStyle: {
      "width": "14px",
      "height": "14px"
    },
    attrs: {
      "src": require("../../assets/images/postion-v2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('el-select', {
    ref: "j-area-select",
    staticClass: "regionSelect areaSelect",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.change_province
    },
    model: {
      value: (_vm.regionBar),
      callback: function($$v) {
        _vm.regionBar = $$v
      },
      expression: "regionBar"
    }
  }, _vm._l((_vm.regionBarOptions), function(item) {
    return (item.label != _vm.regionBar) ? _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    }) : _vm._e()
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "select-change-btn",
    on: {
      "click": _vm.openPicker
    }
  }, [_vm._v("[切换]")])], 1), _vm._v(" "), [_c('el-select', {
    staticClass: "regionSelect fee-select",
    attrs: {
      "value": "",
      "placeholder": "找我婚礼费用说明",
      "popper-class": "fee-select-popper"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "找我婚礼婚礼人其他费用说明"
    }
  }, [_c('div', {
    staticClass: "fee-select-item"
  }, [_c('a', {
    attrs: {
      "href": "https://docs.qq.com/doc/DRUJ6WU1hU1FBU3NJ",
      "target": "_blank"
    }
  }, [_vm._v("找我婚礼婚礼人其他费用说明")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "找我婚礼费用结构说明"
    }
  }, [_c('div', {
    staticClass: "fee-select-item"
  }, [_c('a', {
    attrs: {
      "href": "https://docs.qq.com/sheet/DRURyTEluUlpheU9v",
      "target": "_blank"
    }
  }, [_vm._v("找我婚礼费用结构说明")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "找我婚礼布置费人员价格指导"
    }
  }, [_c('div', {
    staticClass: "fee-select-item"
  }, [_c('a', {
    attrs: {
      "href": "https://docs.qq.com/sheet/DRVpJWU1qWW1KaG54",
      "target": "_blank"
    }
  }, [_vm._v("找我婚礼布置费人员价格指导")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "找我婚礼退单标准说明"
    }
  }, [_c('div', {
    staticClass: "fee-select-item"
  }, [_c('a', {
    attrs: {
      "href": "https://docs.qq.com/sheet/DRWFXbXFqZHByRUZh",
      "target": "_blank"
    }
  }, [_vm._v("找我婚礼退单标准说明")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-arrow-right"
  })])])], 1)]], 2), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "flex-row page-width-header",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c('a', {
    staticClass: "logo",
    attrs: {
      "href": _vm.newUrl,
      "tag": "div"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      selected: false
    }
  }, [_c('a', {
    staticClass: "link menu-item-inner",
    attrs: {
      "href": _vm.newUrl,
      "tag": "a"
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-item"
  }, [_c('a', {
    class: ['link', 'menu-item-inner', {
      selected: false
    }],
    attrs: {
      "target": "_blank",
      "rel": "nofollow",
      "href": "https://1thlook.com/"
    }
  }, [_vm._v("萬拾艺术中心")])]), _vm._v(" "), _vm._l((_vm.menuList), function(menu) {
    return _c('div', {
      key: menu.name,
      staticClass: "menu-item",
      class: {
        selected: menu.selected,
        teamMenu: menu.name === '婚礼团队',
      }
    }, [_c('a', {
      staticClass: "link menu-item-inner",
      attrs: {
        "href": _vm.newUrl + menu.path,
        "tag": "a"
      }
    }, [_vm._v(_vm._s(menu.name))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.name === '婚礼团队'),
        expression: "menu.name === '婚礼团队'"
      }],
      staticClass: "menu-second"
    }, [_c('a', {
      attrs: {
        "href": _vm.newUrl + '/worker/b0'
      }
    }, [_vm._v("策划师")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/worker/b1',
        "to": "/worker/b1"
      }
    }, [_vm._v("化妆师")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/worker/b2',
        "to": "/worker/b2"
      }
    }, [_vm._v("主持人")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/worker/b3',
        "to": "/worker/b3"
      }
    }, [_vm._v("摄影师")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/worker/b4',
        "to": "/worker/b4"
      }
    }, [_vm._v("摄像师")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/planner',
        "to": "/planner"
      }
    }, [_vm._v("统筹师")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.name === '找我案例'),
        expression: "menu.name === '找我案例'"
      }],
      staticClass: "menu-second"
    }, [_c('a', {
      attrs: {
        "href": _vm.newUrl + '/case',
        "to": "/case"
      }
    }, [_vm._v("找我案例")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/explosionCase',
        "to": "/explosionCase"
      }
    }, [_vm._v("爆款案例")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/goodCase',
        "to": "/goodCase"
      }
    }, [_vm._v("专家好评榜")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (menu.name === '找我故事'),
        expression: "menu.name === '找我故事'"
      }],
      staticClass: "menu-second"
    }, [_c('a', {
      attrs: {
        "href": _vm.newUrl + '/ourStory/primacy'
      }
    }, [_vm._v("找我初心")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/ourStory/culture'
      }
    }, [_vm._v("找我文化")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/ourStory/service'
      }
    }, [_vm._v("服务内容")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": _vm.newUrl + '/ourStory/progress'
      }
    }, [_vm._v("找我历程")])]), _vm._v(" "), _c('div', {
      staticClass: "menu-second"
    })])
  }), _vm._v(" "), _c('div', {
    class: ['search-box', {
      'big-search-box': _vm.largeBox
    }]
  }, [_c('div', {
    staticClass: "pic-to-pic-content unblur-1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.boxClick.apply(null, arguments)
      }
    }
  }, [_c('img', {
    staticClass: "unblur-2",
    attrs: {
      "title": "以图搜图",
      "src": "https://img.izhaowo.com/pc-wap/image/pic-search-btn-img.png",
      "alt": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.picSearchChange.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unblur-3",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.searchHeader.apply(null, arguments)
      }
    }
  }, [_vm._v("搜索")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPicToPic),
      expression: "isPicToPic"
    }],
    staticClass: "upload-content",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return (function () {}).apply(null, arguments)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "upload-box"
  }, [_c('UploadImage', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isUploading),
      expression: "isUploading"
    }],
    ref: "UploadAudios",
    attrs: {
      "uploadInfo": _vm.avatarUploadInfo,
      "refName": 'headUpload',
      "autoUpload": false,
      "isMutli": true,
      "maxSize": 5,
      "acceptType": ".png,.jpg,.jpeg",
      "limitSize": 10
    },
    on: {
      "uploading": _vm.uploading,
      "uploadFailed": _vm.uploadFailed,
      "uploaded": _vm.musicUploaded
    }
  })], 1)]), _vm._v(" "), _c('el-input', {
    class: [
      'search-input-select',
      'common-input',
      {
        'big-search': _vm.largeBox,
      } ],
    attrs: {
      "placeholder": _vm.isPicToPic ? '正在以图搜图' : '请输入关键词',
      "size": "mini",
      "readonly": _vm.isPicToPic
    },
    on: {
      "focus": _vm.inputFocus,
      "blur": _vm.inputBlur
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchHeader.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchBarText),
      callback: function($$v) {
        _vm.searchBarText = $$v
      },
      expression: "searchBarText"
    }
  }, [_c('el-select', {
    staticClass: "inner-person-select",
    attrs: {
      "slot": "prepend",
      "placeholder": "请选择",
      "size": "mini"
    },
    slot: "prepend",
    model: {
      value: (_vm.searchBar),
      callback: function($$v) {
        _vm.searchBar = $$v
      },
      expression: "searchBar"
    }
  }, _vm._l((_vm.searchBarOptions), function(item) {
    return _c('el-option', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.value != _vm.searchBar),
        expression: "item.value != searchBar"
      }],
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), (!_vm.largeBox) ? _c('i', {
    staticClass: "el-input__icon index-search-icon el-icon-search",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "click": _vm.searchHeader
    },
    slot: "suffix"
  }) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.largeBox) ? _c('div', {
    staticClass: "user-content"
  }, [(!_vm.isLogin) ? _c('a', {
    staticClass: "without-user-img",
    attrs: {
      "href": _vm.newUrl + '/login'
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userNoneImg,
      "alt": ""
    }
  })]) : _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "width": "88",
      "popper-class": "login-popper",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "user-picker-content"
  }, [_c('span', {
    on: {
      "click": _vm.toUserCenter
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.clearCookie
    }
  }, [_vm._v("退出登录")])]), _vm._v(" "), (_vm.imgsrc) ? _c('img', {
    staticClass: "header-user-img",
    attrs: {
      "slot": "reference",
      "src": _vm._f("imgcrop")(_vm.imgsrc, 32, 32, '', false),
      "alt": ""
    },
    slot: "reference"
  }) : _c('img', {
    attrs: {
      "slot": "reference",
      "src": require("../../assets/images/default-peo.png")
    },
    slot: "reference"
  })])], 1) : _vm._e()], 2), _vm._v(" "), _vm._t("default")], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-right"
  }, [_c('a', {
    staticClass: "go-worker",
    attrs: {
      "href": "https://w.izhaowo.com",
      "target": "_blank"
    }
  }, [_vm._v("婚礼人入驻")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-content-inner"
  }, [_c('img', {
    staticClass: "upload-content-inner-img",
    attrs: {
      "src": "https://img.izhaowo.com/pc-wap/image/pic-search-img-upload-icon.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-content-inner-text"
  }, [_c('span', [_vm._v("将参考图拖拽至此，或")]), _vm._v(" "), _c('span', [_vm._v("点击上传")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71dbb390","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/common/top-bar-new.vue
// module id = 238
// module chunks = 1 5